import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "jumpto-container" }

import { computed } from "vue";
import { JumpToMenuLink } from "@/types/jumpto-menu";
import FlyoutMenu from "@/components/v2/shared/FlyoutMenu.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'JumpToMenu',
  props: {
    menuItems: {}
  },
  setup(__props: any) {

const props = __props;

const menuLinks = computed<JumpToMenuLink[]>(() => {
  if (props.menuItems) {
    return props.menuItems?.filter((l: JumpToMenuLink) => l.visible);
  }
  return [];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FlyoutMenu, {
      title: "Jump To",
      items: menuLinks.value
    }, null, 8, ["items"])
  ]))
}
}

})